import { Component, EventEmitter, ViewEncapsulation, Input, Output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { A11yModule } from '@angular/cdk/a11y';

import { DatacenterCodeTranslationFilterType,
	DynamicDatacenterFilter, SuggestiveListFilter } from '../../../models/datacenter-filters';
import { pageTransitions } from '../../../animations/page-transitions';
import { DatacenterFilterApiService } from '../../../services/datacenter-filter-api.service';

import { SuggestiveItemFilterComponent } from './suggestive-item-filter.component';

@Component({
	selector: 'copo-suggestive-list-filter',
	templateUrl: './suggestive-list-filter.component.html',
	styleUrl: './suggestive-list-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	providers: [DatacenterFilterApiService],
	imports: [NgIf, NgFor, MatIconModule, MatRippleModule, SuggestiveItemFilterComponent, MatButtonModule, A11yModule]
})
export class SuggestiveListFilterComponent implements DynamicDatacenterFilter<SuggestiveListFilter> {
	@Input() filter?: SuggestiveListFilter;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;

	removeValue(item: DatacenterCodeTranslationFilterType) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(this.filter.getValues().findIndex(search => search.code === item.code), 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return {
				id: this.filter.filterId,
				values: this.filter.getValues()
					.filter(filterValue => !filterValue.translation)
			};
		}
		return undefined;
	}
}
